<template>
  <div class="h-auto px-2 lg:px-0 pb-20 w-[99%] mx-auto">
    <h1 class="font-display text-gray-900 font-bold text-basicTitle pb-10 mx-5 lg:mx-0">{{ $t('cashback').tTitle() }}</h1>

    <div class="grid grid-cols-1 l150:grid-cols-2 gap-8 md:gap-10">
      <div class="bg-white rounded-lg shadow-ts1 px-5 py-10 md:px-[100px] md:pt-[54px] flex flex-col">
        <img src="@/assets/img/cashback/what-is-cashback-intro.svg" :alt="$t('cashback_what_is').tTitle()" class="w-full m-auto max-w-[300px] h-auto mb-6" />
        <div class="flex flex-col">
          <h2 class="font-display text-[40px] leading-[47px] font-bold text-blue mb-9 md:mb-8">{{ $t('cashback_what_is').tTitle() }}</h2>
          <p class="font-body text-base text-gray-900 leading-7 mb-5 max-w-md">{{ $t('cashback_intro_description') }}</p>

          <div class="form-check w-full ltr:text-left rtl:text-right mb-6">
            <input class="checkbox cashback-checkbox" type="checkbox" id="cashback_terms" name="cashback_terms" value="" v-model="termsAccepted" :disabled="applying" />
            <label class="checkbox-label-xs" for="cashback_terms" id="lbl-cashback-apply" v-html="$t('cashback_terms_accepted', { URL: termsUrl })"></label>
          </div>

          <Button mode="secondary" :disabled="!termsAccepted || applying || !this.IsVerified" :loading="applying" customClasses="!w-fit leading-5 px-5 py-4" @click="apply">
            {{ $t('cashback_apply').tTitle() }}
          </Button>
        </div>
      </div>

      <div class="bg-blue rounded-lg shadow-ts1 px-5 py-[52px] md:px-10 md:py-10">
        <h2 class="font-display text-[28px] leading-[48px] font-bold text-white mb-8">{{ $t('cashback_how_it_works').tTitle() }}</h2>
        <div v-for="(step, index) in steps" :key="index" class="mb-10 md:mb-12 last:mb-0">
          <p class="text-gold font-body text-sm mb-1">{{ step.label }}</p>
          <p class="text-white font-body font-semibold text-[20px] mb-1">{{ step.title }}</p>
          <p class="text-white font-body text-base">{{ step.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/reusableComponents/Button.vue'
import links from '@/config/links'
import { service } from '../../main.js'
import { mapGetters } from 'vuex'

export default {
  components: { Button },
  data() {
    return {
      termsAccepted: false,
      applying: false,
    }
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      UserInfo: 'user/info',
      IsVerified: 'user/isVerified',
    }),
    termsUrl() {
      return links.getLink('cashbackTermsConditions', this.Language)
    },
    steps() {
      return [
        {
          label: this.$t('cashback_step_01'),
          title: this.$t('cashback_step_1_title').tTitle(),
          description: this.$t('cashback_step_1_description'),
        },
        {
          label: this.$t('cashback_step_02'),
          title: this.$t('cashback_step_2_title').tTitle(),
          description: this.$t('cashback_step_2_description'),
        },
        {
          label: this.$t('cashback_step_03'),
          title: this.$t('cashback_step_3_title').tTitle(),
          description: this.$t('cashback_step_3_description'),
        },
        {
          label: this.$t('cashback_step_04'),
          title: this.$t('cashback_step_4_title').tTitle(),
          description: this.$t('cashback_step_4_description'),
        },
      ]
    },
  },
  methods: {
    apply() {
      if (!this.termsAccepted) return
      if (!this.IsVerified) return
      this.applying = true
      service
        .post('/cashback/enroll', {
          userID: this.UserInfo.ID,
        })
        .then(response => {
          if (response) {
            this.$emit('activated')
            this.applying = false
          }
        })
        .catch(error => {
          this.applying = false
          this.$toasted.error(this.$t(error.response?.data?.meta?.messageID), { duration: 10000 })
        })
    },
  },
}
</script>
<style scoped>
.cashback-checkbox:checked {
  @apply bg-green text-white;
}
</style>
